export function checksession() {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({})
    };
    return fetch('/shared/api/auth/checksession', requestOptions).then((response) => response.json())
}